

export const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    {
        title: '库区名称',
        dataIndex: 'regionName',
        key: 'regionName'
    },
    {
        title: '库区',
        dataIndex: 'shelf',
        key: 'shelf'
    },
    {
        title: '通道',
        dataIndex: 'aisle',
        key: 'aisle',
        customRender: (text, record, index) => {
          return text.replace(/[^0-9]/ig,"");
        },
    },
    {
        title: '列',
        dataIndex: 'tier',
        key: 'tier'
    },
    {
        title: '层',
        dataIndex: 'series',
        key: 'series'
    },
    {
        title: '库位编码',
        dataIndex: 'gridCode',
        key: 'gridCode',
    },
    {
        title: '操作',
        dataIndex: 'id',
        key: 'idAction',
        scopedSlots: {
            customRender: 'action'
        }
    },
]